import { useState } from "react";
import EconomicActivity from "../../models/economic-activity";
import { CCard, CCardBody, CCardHeader, CCollapse } from "@coreui/react";

import EconomicActivityCrudActions from "./EconomicActivityCrudActions";

interface EconomicActivityCardProps {
  economicActivity: EconomicActivity;
  onUpdateClick: (inv: EconomicActivity) => void;
  onDeleteClick: (inv: EconomicActivity) => void;
  isDemo?: boolean;
}

export function EconomicActivityCard({
  economicActivity,
  onUpdateClick,
  onDeleteClick,
  isDemo,
}: EconomicActivityCardProps) {
  const [open, setOpen] = useState(true);
  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{economicActivity.code}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{""}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1 border border-dark"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Código:</strong> {economicActivity.code}
          </p>
          <p>
            <strong>Descripción:</strong> {economicActivity.description}
          </p>
          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <EconomicActivityCrudActions
              economicActivity={economicActivity}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
              isDemo={isDemo}
            />
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
